import { render } from "./ModelDocTab.vue?vue&type=template&id=58757f34&scoped=true"
import script from "./ModelDocTab.vue?vue&type=script&lang=js"
export * from "./ModelDocTab.vue?vue&type=script&lang=js"

import "./ModelDocTab.vue?vue&type=style&index=0&id=58757f34&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58757f34"]])

export default __exports__